import { render, staticRenderFns } from "./AddressBookList.vue?vue&type=template&id=02d2df2c"
import script from "./AddressBookList.vue?vue&type=script&lang=js"
export * from "./AddressBookList.vue?vue&type=script&lang=js"
import style0 from "./AddressBookList.vue?vue&type=style&index=0&id=02d2df2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports